import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';
import AsyncSelect from '../../../shared/AsyncSelect/AsyncSelect';
import Button from '../../../shared/Button/Button';
import TextField from '../../../shared/FormFields/TextFieldWithLabel';
import SelectField from '../../../shared/FormFields/SelectFieldWithLabel';
import CheckboxContainer from '../../../shared/FormFields/CheckboxContainer';
import RadioContainer from '../../../shared/FormFields/RadioContainer';
import { withRouter, browserHistory } from 'react-router';

import { saveAccount, getUserProfile } from '../../../../redux/modules/user';
import { loadCities } from '../../../../redux/modules/cities';
import { loadCountries } from '../../../../redux/modules/countries';

import {
  codiceFiscaleValido,
  cognomeCoerente,
  nomeCoerente,
  getSesso,
} from '../../../shared/lib/codiceFiscale';

import './Profilo.scss';

class Profilo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isEditing: false,
      fromCheckout: false,
    };
  }

  componentDidMount() {
    this.props.loadCountries();
    if (this.props.location.query.modifica) {
      this.setState({
        isEditing: true,
        fromCheckout: true,
      });
    }
  }

  componentDidUpdate(oldProps) {
    if (oldProps.country !== this.props.country && oldProps.country) {
      this.props.change('shipping.city', '');
    }
  }

  saveAccount = userData => {
    window.scrollTo(0, 0);

    const { id, billing, shipping, hasSubscribedToNewsletter } = userData;
    const userToSend = { billing, shipping, hasSubscribedToNewsletter };
    this.props.saveAccount(id, userToSend);

    this.setState({
      isEditing: false,
    });
    if (this.props.location.query.modifica) {
      browserHistory.push('/carrello');
    }
  };

  setEditing = () => {
    this.setState({
      isEditing: true,
    });
  };

  doneEditing = () => {
    this.setState({
      isEditing: false,
    });
  };

  ///////////////////////////////////////////////////////////////
  // GESTIONE COMUNI AUTOCOMPLETE

  getCities = (input, callback) => {
    if (!input) {
      if (!!callback) {
        callback(null, {
          options: [],
        });
      }
    }

    this.props.loadCities(input || null, 4).then(action => {
      if (!!callback) {
        callback(null, {
          options:
            !!action.payload && !!action.payload.length
              ? action.payload.map(city => {
                  return {
                    value: `${city.city}|${city.province}`,
                    label: `${city.city} (${city.province})`,
                  };
                })
              : [],
        });
      }
    });
  };

  renderSelectCities = ({
    input,
    id,
    name,
    label,
    type,
    placeholder,
    meta: { touched, error },
  }) => {
    return (
      <div className={`form-group ${touched && error && 'error'}`}>
        <label htmlFor={id} className="col-sm-4 control-label">
          {label}
        </label>
        <div className="col-sm-8">
          <AsyncSelect
            name={name}
            value={input.value}
            openOnClick={false}
            loadOptions={this.getCities}
            labelKey="label"
            valueKey="value"
            onChange={val => {
              if (val && val.value) {
                input.onChange(val);
              } else {
                input.onChange('');
              }
            }}
            onBlur={() => input.onBlur(input.value)}
            placeholder="Città"
            loadingPlaceholder="Caricamento..."
            clearValueText="Annulla"
            searchPromptText="Digita la città..."
          />

          {touched && error && <div className="error-text">{error}</div>}
        </div>
      </div>
    );
  };
  ///////////////////////////////////////////////////////////////

  // renderField({ input, id, label, type, placeholder, meta: { touched, error } }) {
  //   return (
  //     <div className={`form-group ${touched && error && 'error'}`}>
  //       <label htmlFor={id} className="col-sm-4 control-label">
  //         {label}
  //       </label>
  //       <div className="col-sm-8">
  //         <input {...input} id={id} placeholder={placeholder} type={type} className="form-control" />
  //         {touched && error && <div className="error-text">{error}</div>}
  //       </div>
  //     </div>
  //   )
  // }
  renderMarketingCheck = ({ input, type, meta: { touched, error } }) => {
    const { privacy } = this.props;
    if (!!privacy && !!privacy.marketingText) {
      return (
        <CheckboxContainer
          className={`newsletter-checkbox ${touched && error && 'error'}`}
        >
          <input {...input} id="hasSubscribedToNewsletter" type={type} />
          <label
            htmlFor="hasSubscribedToNewsletter"
            dangerouslySetInnerHTML={{
              __html: privacy.marketingText,
            }}
          />
          {touched && error && <div className="error-text">{error}</div>}
        </CheckboxContainer>
      );
    }

    return (
      <CheckboxContainer className="newsletter-checkbox">
        <input {...input} id="hasSubscribedToNewsletter" type={type} />
        <label htmlFor="hasSubscribedToNewsletter">
          Desidero restare aggiornato sugli sconti e promozioni e acconsento
          all’uso dei miei dati per finalità commerciali
        </label>
      </CheckboxContainer>
    );
  };

  render() {
    const user = this.props.user.data;
    const { primaryColor, hasSalesAbroad, country, countries } = this.props;
    return (
      <div className="profilo">
        {!this.state.isEditing ? (
          <div>
            <div className="row">
              <div className="col-md-6">
                <h3>Dati di fatturazione</h3>
                <address
                  className="billing-address"
                  style={{ borderColor: primaryColor }}
                >
                  {!!this.props.isCompany && (
                    <p style={{ marginBottom: 0 }}>{user.billing.company}</p>
                  )}
                  {user.billing.firstname} {user.billing.lastname}
                  <br />
                  {user.billing.address1 && (
                    <>
                      {user.billing.address1}
                      <br />
                    </>
                  )}
                  {user.billing.address2 && (
                    <span>
                      {user.billing.address2}
                      <br />
                    </span>
                  )}
                  {(user.billing.zipcode ||
                    user.billing.city ||
                    user.billing.zipcode) && (
                    <>
                      {user.billing.zipcode && user.billing.zipcode}{' '}
                      {user.billing.city && user.billing.city}{' '}
                      {user.billing.province && user.billing.province}
                      <br />
                    </>
                  )}
                  {(user.billing.taxCode || user.billing.vatNumber) && (
                    <>
                      {' '}
                      {user.billing.taxCode && `C.F. ${user.billing.taxCode}`}
                      {user.billing.vatNumber &&
                        ' - P.IVA ' + user.billing.vatNumber}
                      <br />
                    </>
                  )}
                  {user.billing.phone && `Tel. ${user.billing.phone}`}
                </address>
              </div>
              <div className="col-md-6">
                <h3>Dati di spedizione</h3>
                <address
                  className="shipping-address"
                  style={{ borderColor: primaryColor }}
                >
                  {user.shipping.name && (
                    <>
                      {user.shipping.name}
                      <br />
                    </>
                  )}
                  {user.shipping.address1 && (
                    <>
                      {user.shipping.address1}
                      <br />
                    </>
                  )}
                  {user.shipping.address2 && (
                    <span>
                      {user.shipping.address2}
                      <br />
                    </span>
                  )}
                  {(user.shipping.zipcode ||
                    user.shipping.city ||
                    user.shipping.province) && (
                    <>
                      {user.shipping.zipcode && user.shipping.zipcode}{' '}
                      {user.shipping.city && user.shipping.city}
                      {user.shipping.province && user.shipping.province}
                      <br />
                    </>
                  )}

                  {hasSalesAbroad && (
                    <>
                      {user.shipping.country && user.shipping.country}
                      <br />
                    </>
                  )}
                  {user.shipping.phone && `Tel. ${user.shipping.phone}`}
                </address>
              </div>
            </div>

            <hr />

            <div className="btn-container">
              <Button
                className="btn btn-thick btn-primary"
                onClick={this.setEditing}
              >
                Modifica
              </Button>
            </div>
          </div>
        ) : (
          <form
            className="form-horizontal"
            onSubmit={this.props.handleSubmit(this.saveAccount)}
          >
            {this.state.fromCheckout && (
              <div
                className="row"
                style={{ padding: '0 0 24px', fontSize: 16 }}
              >
                <div className="col-sm-12">
                  <span>
                    Compila tutti i dati per poter procedere al checkout
                  </span>
                </div>
              </div>
            )}
            <div className="row">
              <div className="col-md-6">
                <h3>Dati di fatturazione</h3>
                <div className="form-group is-company-radios">
                  <div className="row">
                    <div className="col-sm-4 col-sm-offset-4">
                      <RadioContainer>
                        <Field
                          name="billing.isCompany"
                          id="isPrivate"
                          component="input"
                          type="radio"
                          value="false"
                        />
                        <label htmlFor="isPrivate">Privato</label>
                      </RadioContainer>
                    </div>
                    <div className="col-sm-4">
                      <RadioContainer>
                        <Field
                          name="billing.isCompany"
                          id="isCompany"
                          component="input"
                          type="radio"
                          value="true"
                        />
                        <label htmlFor="isCompany">Azienda</label>
                      </RadioContainer>
                    </div>
                  </div>
                </div>

                {this.props.isCompany === 'true' ? (
                  <Field
                    name="billing.company"
                    component={TextField}
                    id="billing.company"
                    placeholder={user.billing.company}
                    type="text"
                    label="Ragione sociale"
                  />
                ) : null}
                <Field
                  name="billing.firstname"
                  component={TextField}
                  id="billing.firstname"
                  placeholder={user.billing.firstname}
                  type="text"
                  label="Nome"
                />
                <Field
                  name="billing.lastname"
                  component={TextField}
                  id="billing.lastname"
                  placeholder={user.billing.lastname}
                  type="text"
                  label="Cognome"
                />

                <Field
                  name="billing.taxCode"
                  component={TextField}
                  id="billing.taxCode"
                  placeholder={user.billing.taxCode}
                  type="text"
                  label="Codice fiscale"
                  normalize={normalizeTaxCode}
                />
                {this.props.isCompany === 'true' && (
                  <div>
                    <Field
                      name="billing.vatNumber"
                      component={TextField}
                      placeholder={user.billing.vatNumber}
                      type="text"
                      label="P.IVA"
                    />
                    <Field
                      name="billing.sdiCode"
                      component={TextField}
                      placeholder={user.billing.sdiCode}
                      type="text"
                      label="Codice univoco SDI"
                    />
                    <Field
                      name="billing.pec"
                      component={TextField}
                      placeholder={user.billing.pec}
                      type="text"
                      label="Indirizzo PEC"
                    />
                  </div>
                )}

                <Field
                  name="billing.address1"
                  component={TextField}
                  id="billing.address1"
                  placeholder={user.billing.address1}
                  type="text"
                  label="Indirizzo"
                />
                <Field
                  name="billing.address2"
                  component={TextField}
                  id="billing.address2"
                  placeholder={user.billing.address2}
                  type="text"
                  label="Note indirizzo"
                />
                <Field
                  name="billing.zipcode"
                  component={TextField}
                  id="billing.zipcode"
                  placeholder={user.billing.zipcode}
                  type="text"
                  label="CAP"
                  normalize={normalizeZipcode}
                />
                <Field
                  name="billing.city"
                  id="billing.city"
                  component={this.renderSelectCities}
                  label="Città"
                />
                <Field
                  name="billing.phone"
                  component={TextField}
                  id="billing.phone"
                  placeholder={user.billing.phone}
                  type="text"
                  label="Telefono"
                />
              </div>
              <div className="col-md-6">
                <h3>Dati di spedizione</h3>
                <Field
                  name="shipping.name"
                  component={TextField}
                  id="shipping.name"
                  placeholder={user.shipping.name}
                  type="text"
                  label="Destinatario"
                />
                <Field
                  name="shipping.address1"
                  component={TextField}
                  id="shipping.address1"
                  placeholder={user.shipping.address1}
                  type="text"
                  label="Indirizzo"
                />
                <Field
                  name="shipping.address2"
                  component={TextField}
                  id="shipping.address2"
                  placeholder={user.shipping.address2}
                  type="text"
                  label="Note indirizzo"
                />
                <Field
                  name="shipping.zipcode"
                  component={TextField}
                  id="shipping.zipcode"
                  placeholder={user.shipping.zipcode}
                  type="text"
                  label="CAP"
                  normalize={normalizeZipcode}
                />
                {hasSalesAbroad && (
                  <Field
                    name="shipping.country"
                    component={SelectField}
                    label="Nazione"
                    nullOption={{
                      value: 'Italia',
                      label: 'Italia',
                    }}
                    options={countries.map(c => ({
                      value: c.name,
                      label: c.name,
                    }))}
                  />
                )}
                {hasSalesAbroad && country !== 'Italia' ? (
                  <Field
                    name="shipping.city"
                    id="shipping.city"
                    component={TextField}
                    label="Città"
                  />
                ) : (
                  <Field
                    name="shipping.city"
                    id="shipping.city"
                    component={this.renderSelectCities}
                    label="Città"
                  />
                )}
                <Field
                  name="shipping.phone"
                  component={TextField}
                  id="shipping.phone"
                  placeholder={user.shipping.phone}
                  type="text"
                  label="Telefono"
                />
              </div>
              {/* Aggiunto qui flag marketing perchè se in admin è selezionata la registrazione semplice, allora in fase di registrazione non viene richiesto. */}
              <div>
                <Field
                  name="hasSubscribedToNewsletter"
                  component={this.renderMarketingCheck}
                  type="checkbox"
                />
              </div>
            </div>
            <hr />
            <div className="btn-container">
              <Button
                className="btn btn-thick btn-grey"
                onClick={this.doneEditing}
              >
                Annulla modifiche
              </Button>
              <Button type="submit" className="btn btn-thick btn-primary">
                Salva modifiche
              </Button>
            </div>
          </form>
        )}
      </div>
    );
  }
}

const validate = values => {
  const errors = {
    shipping: {},
    billing: {},
  };
  if (values.shipping) {
    if (!values.shipping.name) {
      errors.shipping.name = 'Richiesto';
    }
    if (!values.shipping.address1) {
      errors.shipping.address1 = 'Richiesto';
    }
    if (!values.shipping.city) {
      errors.shipping.city = 'Richiesto';
    }
    if (!values.shipping.zipcode) {
      errors.shipping.zipcode = 'Richiesto';
    }
    if (!values.shipping.phone) {
      errors.shipping.phone = 'Richiesto';
    }
  }
  if (values.billing) {
    if (!values.billing.company) {
      errors.billing.company = 'Richiesto';
    }
    if (!values.billing.firstname) {
      errors.billing.firstname = 'Richiesto';
    }
    if (
      !nomeCoerente(values.billing.taxCode, values.billing.firstname) &&
      values.billing.isCompany != 'true'
    ) {
      errors.billing.firstname = 'Nome non coerente con Codice Fiscale';
    }
    if (!values.billing.lastname) {
      errors.billing.lastname = 'Richiesto';
    }
    if (
      !cognomeCoerente(values.billing.taxCode, values.billing.lastname) &&
      values.billing.isCompany != 'true'
    ) {
      errors.billing.lastname = 'Cognome non coerente con Codice Fiscale';
    }
    if (!values.billing.vatNumber) {
      errors.billing.vatNumber = 'Richiesto';
    }
    if (!values.billing.sdiCode && !values.billing.pec) {
      errors.billing.sdiCode = 'Richiesti codice SDI o PEC';
      errors.billing.pec = 'Richiesti codice SDI o PEC';
    }
    if (!values.billing.taxCode) {
      errors.billing.taxCode = 'Richiesto';
    } else if (
      !codiceFiscaleValido(values.billing.taxCode) &&
      values.billing.isCompany != 'true'
    ) {
      errors.billing.taxCode = 'Codice fiscale non valido';
    }

    if (!values.billing.address1) {
      errors.billing.address1 = 'Richiesto';
    }
    if (!values.billing.city) {
      errors.billing.city = 'Richiesto';
    }
    if (!values.billing.zipcode) {
      errors.billing.zipcode = 'Richiesto';
    }
    if (!values.billing.phone) {
      errors.billing.phone = 'Richiesto';
    }
  }

  return errors;
};

const normalizeTaxCode = value => (value || '').toUpperCase();
const normalizeZipcode = value => (value || '').replace(/[^\d]/g, '');

Profilo = reduxForm({
  form: 'profile',
  enableReinitialize: true,
  validate,
})(Profilo);

const mapStateToProps = state => {
  const selector = formValueSelector('profile');

  return {
    hasSalesAbroad: state.store.data.features.hasSalesAbroad,
    user: state.user,
    isCompany: '' + selector(state, 'billing.isCompany'),
    country: selector(state, 'shipping.country'),
    city: selector(state, 'shipping.city'),
    initialValues: getUserProfile(state),
    primaryColor: state.store.data.loghiTemplate.brandColor,
    countries: state.countries.data,
    privacy: state.store.data.funzionalita.privacy,
  };
};

export default withRouter(
  connect(mapStateToProps, { saveAccount, loadCities, loadCountries })(Profilo)
);
